export const contactEvent = async () => {
    fbq("track", "Contact");
}

export const purchaseEvent = async (contents, content_ids, product, value, utm_source, utm_campaign, utm_medium, utm_action, utm_platform) => {
    if (utm_source && utm_medium && utm_campaign && utm_action && utm_platform) {
        fbq('track', 'Purchase', {
            contents: contents,
            content_ids: content_ids,
            content_type: product,
            quantity: 1,
            currency: 'THB',
            value: value,
            utm_source: utm_source,
            utm_campaign: utm_campaign,
            utm_medium: utm_medium,
            utm_action: utm_action,
            utm_platform: utm_platform,
        });
    } else {
        fbq('track', 'Purchase', {
            contents: contents,
            content_ids: content_ids,
            content_type: product,
            quantity: 1,
            currency: 'THB',
            value: value,
        });
    }
}